import type React from 'react';

import PageHeaderActions from './components/PageHeaderActions';
import PageHeaderTitle from './components/PageHeaderTitle';

export interface PageHeaderProps {
  children: React.ReactNode;
}

const PageHeader = ({ children }: PageHeaderProps) => {
  return (
    <div className='flex justify-between gap-5 border-b border-gray-light pb-2'>
      {children}
    </div>
  );
};

PageHeader.Title = PageHeaderTitle;
PageHeader.Actions = PageHeaderActions;

export default PageHeader;
